/* eslint-disable no-multi-assign,no-plusplus,@typescript-eslint/no-unused-vars,prefer-rest-params,prefer-spread */

xplenty.service('segment', [
  '$window',
  'utils',
  function ($window, utils) {
    const segment = {};
    const { slice } = Array.prototype;

    segment.init = function (appKey) {
      // Create a queue, but don't obliterate an existing one!
      const analytics = (window.analytics = window.analytics || []);

      // If the real analytics.js is already on the page return.
      if (analytics.initialize) return;

      // If the snippet was invoked already show an error.
      if (analytics.invoked) {
        if (window.console && console.error) {
          console.error('Segment snippet included twice.');
        }
        return;
      }

      // Invoked flag, to make sure the snippet
      // is never invoked twice.
      analytics.invoked = true;

      // A list of the methods in Analytics.js to stub.
      analytics.methods = [
        'trackSubmit',
        'trackClick',
        'trackLink',
        'trackForm',
        'pageview',
        'identify',
        'reset',
        'group',
        'track',
        'ready',
        'alias',
        'page',
        'once',
        'off',
        'on',
      ];

      // Define a factory to create stubs. These are placeholders
      // for methods in Analytics.js so that you never have to wait
      // for it to load to actually record data. The `method` is
      // stored as the first argument, so we can replay the data.
      analytics.factory = function (method) {
        return function () {
          const args = Array.prototype.slice.call(arguments);
          args.unshift(method);
          analytics.push(args);
          return analytics;
        };
      };

      // For each of our methods, generate a queueing stub.
      for (let i = 0; i < analytics.methods.length; i++) {
        const key = analytics.methods[i];
        analytics[key] = analytics.factory(key);
      }

      // Define a method to load Analytics.js from our CDN,
      // and that will be sure to only ever load it once.
      analytics.load = function (key) {
        // Create an async script element based on your key.
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.async = true;
        script.src = `${
          document.location.protocol === 'https:' ? 'https://' : 'http://'
        }cdn.segment.com/analytics.js/v1/${key}/analytics.min.js`;

        // Insert our script next to the first script element.
        const first = document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(script, first);
      };

      // Add a version to keep track of what's in the wild.
      analytics.SNIPPET_VERSION = '3.1.0';

      // Load Analytics.js with your key, which will automatically
      // load the tools you've enabled for your account. Boosh!
      analytics.load(appKey);
    };

    segment.identify = function () {
      const args = slice.call(arguments);
      return analytics.identify.apply(analytics, args, {
        Intercom: { hideDefaultLauncher: true },
      });
    };

    segment.group = function () {
      const args = slice.call(arguments);
      return analytics.group.apply(analytics, args, {
        Intercom: { hideDefaultLauncher: true },
      });
    };

    segment.page = function () {
      const args = slice.call(arguments);
      return analytics.page.apply(analytics, args, {
        Intercom: { hideDefaultLauncher: true },
      });
    };

    segment.shutdown = function () {
      // Intercom specific shutdown script - https://developers.intercom.com/docs/integrate-intercom-in-a-single-page-app
      if (typeof window.Intercom !== 'undefined') {
        window.Intercom('shutdown');
      }
    };

    segment.ready = function () {
      const args = slice.call(arguments);
      return analytics.ready.apply(analytics, args);
    };

    window.intercomSettings = {
      alignment: 'left',
      hide_default_launcher: true,
      horizontal_padding: 55,
      vertical_padding: 55,
    };

    return segment;
  },
]);
